import { Button, Icon } from '@platform/components';

export const CommunityBackButton = () => {
  return (
    <div className='w-full flex justify-left'>
      <Button href='/platform/dashboard/community' variant='link-color' size='sm'>
        <Icon size='20' type='arrow-left' /> Back to community
      </Button>
    </div>
  );
};
